import { observer } from "mobx-react-lite";
import React from "react";

import AppStore from "stores/AppStore";

import "./BenefitsListTableHeader.scss";

const BenefitsListTableHeader = () => {
    const {
        i18n: {
          benefits: {family, name, price, active, base}
        }
    } = AppStore;

    return (
        <thead className="c-benefits-list-table-header">
            <tr className="c-benefits-list-table-header__tr">
              <th className="c-benefits-list-table-header__th u-align-left">{family}</th>
              <th className="c-benefits-list-table-header__th u-align-left">{name}</th>
              <th className="c-benefits-list-table-header__th u-align-left" >{active}</th>
              <th className="c-benefits-list-table-header__th u-align-left" >{base}</th>
              <th className="c-benefits-list-table-header__th u-align-left">{price}</th>
            </tr>
        </thead>
    );
};

export default observer(BenefitsListTableHeader);
